var ClipToCardAction = {
    /*
     Required external 'global' Vars:
     - titleTextClip
     - titleTextUnclip
     - titleUnclipNotAllowed
     - clipErrorMsg
     - unclipErrorMsg
     */
    initClipToCardAction: function ($container) {
        var clipToCardActionUrl = "/my-coupon/clip-to-card/";
        var $clipToCardButton;

        if ($container) {
            $clipToCardButton = $container.find(".coupons-ctc-button")
        } else {
            $clipToCardButton = $(".coupons-ctc-button");
        }

        $clipToCardButton.on('click', _.debounce(function () {
            $("#clip-error").hide();

            var $self = $(this);
            var $couponTile = $self.closest('.article.coupon--bloc');
            var $clipHeaderBtn = $couponTile.find('.coupons-ctc-header-button');
            var $clipBtns = $clipHeaderBtn.length ? $self.add($clipHeaderBtn) : $self;

            ClipToCardAction.disableElement($clipBtns);

            var data = {};

            var isClipped = $self.hasClass("clipped");
            if (isClipped) {
                var xcCouponId = $self.attr("data-coupon-xcid");
                ClipToCardAction.unclip(clipToCardActionUrl, xcCouponId, $self);
            } else {
                var couponId = $self.attr("data-coupon-id");
                var metroCouponId = $self.closest('.coupon-addToCart').attr('data-coupon-metrocouponid');
                ClipToCardAction.clip(clipToCardActionUrl, couponId, data, $self);
                pushDataLayerClipOneCoupon(metroCouponId, loyaltyProgram);
            }
        }, 200));

        $('.coupons-ctc-header-button').on('click', function () {
            var $couponTile = $(this).closest('article.coupon--bloc');
            $couponTile.find('.coupons-ctc-button').trigger('click');
        });

        $('.coupons-clip-all-btn').on('click', function () {
            ClipToCardAction.disableElement($(this));
            var couponIds = $("button[data-coupon-id]:not(.clipped)").map(function () {
                return $(this).closest('.coupon-addToCart').attr('data-coupon-metrocouponid');
            }).get();
            var couponIdsJoined = couponIds.join('|');

            if (!couponIdsJoined) {
                couponIdsJoined = "aucun";
            } else {
                for (var i = 0; i < couponIds.length; ++i) {
                    _push_custom_event_to_GA4(
                        'coupon_clip',
                        'coupon_id', couponIds[i]
                    );
                }
            }
            pushDataLayerClipAllCoupons(couponIdsJoined, loyaltyProgram);

            var location = window.location.pathname;
            window.location.href = location + (location.slice(-1) === "/" ? "clip-all" : "/clip-all");
        });

        if (localStorage.getItem('hideClipToCardModal ') !== "true") {
            $('[data-module~="dishide--coupon-help"]').dishide();
        }
    },

    disableElement: function ($self) {
        $self.prop("disabled", true);
    },

    enableElement: function ($self) {
        $self.prop("disabled", false);
    },

    unclip: function (baseUrl, xcCouponId, $self, callback) {
        var $couponTile = $self.closest('article.coupon--bloc');
        var $clipHeaderBtn = $couponTile.find('.coupons-ctc-header-button');
        var $clipBtns = $clipHeaderBtn.length ? $self.add($clipHeaderBtn) : $self;

        $.ajax({
            url: baseUrl + xcCouponId,
            type: "DELETE",
            headers: {
                "Accept-Language": lang
            },
            success: function (responseData) {
                ClipToCardAction.refreshButtonForClip($self);
                ClipToCardAction.refreshCouponHeaderForClip($couponTile);
                ClipToCardAction.enableElement($clipBtns);
                ClipToCardAction.decrementClippedDisplayCount();
                ClipToCardAction.refreshNbItemsInShoppingList(responseData.shoppingListNbItems);
                ClipToCardAction.refreshActions();

                if (ClipToCardAction.isActionFromShoppingList($self)) {

                    // Hide category title if no families present (items)
                    var $slItemList = $self.closest('.sl--family-wrap');
                    var familyId = $slItemList.attr("id");

                    ClipToCardAction.refreshShoppingListItem($self, true);

                    // Hide category title if no families present (items)
                    $slItemList = $("#" + familyId);
                    if ($slItemList.children().length == 0) {
                        $slItemList.prev().hide();
                        $slItemList.next().hide();
                        $slItemList.hide();
                    }
                }
                var couponId = $self.attr("data-coupon-id");
                ClipToCardAction.recordUnclipEvent(couponId, xcCouponId);

                if (typeof callback !== "undefined") {
                    callback(responseData);
                }
            },
            error: function (responseData) {
                if (!TINK.redirectIfConflict(responseData)) {
                    let coupon = $.parseJSON(responseData.responseText);
                    let spanExpiration = $couponTile.find('div.coupon-bottom .expiration');
                    if (coupon.couponValidityExpired) {
                        ClipToCardAction.showError(unclipCouponValidityExpiredText);
                        $self.addClass('not-clippable');
                        $self.find('.clip-red-ellipse').removeClass('red-ellipse-remove').html('<img data-src="/images/shared/small/icons/lock-coupon.svg" class="inject-me" alt=""/>');
                        injectSVG($couponTile.get(0));
                        $clipBtns.attr('title', titleClipNotAllowed);
                        ClipToCardAction.disableElement($clipBtns);
                        spanExpiration.html(couponAvailableSoon);
                        ClipToCardAction.refreshCouponHeaderForClip($couponTile);
                    } else {
                        ClipToCardAction.showError(unclipErrorMsg);
                        $self.attr('title', titleTextUnclip);
                        if (typeof $self !== "undefined") {
                            ClipToCardAction.enableElement($clipBtns);
                        }
                    }
                }
            }
        });
    },

    clip: function (baseUrl, couponId, data, $self, callback) {
        var $couponTile = $self.closest("article.coupon--bloc");
        var $clipHeaderBtn = $couponTile.find('.coupons-ctc-header-button');
        var $clipBtns = $clipHeaderBtn.length ? $self.add($clipHeaderBtn) : $self;

        $.ajax({
            url: baseUrl + couponId,
            type: "POST",
            xhrFields: {
                withCredentials: true
            },
            headers: {
                "Accept-Language": lang
            },
            data: data,
            success: function (responseData) {
                var unclippable = !$couponTile.hasClass('unclipDeactivated');
                ClipToCardAction.refreshButtonForUnclip($self, responseData.xcCouponId, unclippable);
                ClipToCardAction.refreshCouponHeaderForUnclip($couponTile, unclippable);
                if (unclippable) {
                    ClipToCardAction.enableElement($clipBtns);
                } else {
                    ClipToCardAction.disableElement($clipBtns);
                }

                ClipToCardAction.incrementClippedDisplayCount();
                ClipToCardAction.refreshNbItemsInShoppingList(responseData.shoppingListNbItems);
                ClipToCardAction.refreshActions();

                if (ClipToCardAction.isActionFromShoppingList($self)) {
                    ClipToCardAction.refreshShoppingListItem($self, false);
                }

                if (typeof callback !== "undefined") {
                    callback(responseData);
                }
            },
            error: function (responseData) {
                if (!TINK.redirectIfConflict(responseData)) {
                    let coupon = $.parseJSON(responseData.responseText);
                    let spanExpiration = $couponTile.find('div.coupon-bottom .expiration');
                    let spanExpirationLegal = $('[data-remodal-id=modal-coupon-legal' + $self.attr("data-coupon-id") + ']').find('div.coupon-bottom .expiration');
                    if (coupon.couponLimitReached || coupon.couponValidityExpired) {
                        if (coupon.couponLimitReached) {
                            ClipToCardAction.showError(clipErrorMsgLimitReached);
                            spanExpiration.html(couponSoldOut).addClass('sold-out');
                            spanExpirationLegal.html(couponSoldOut).addClass('sold-out');
                        } else {
                            ClipToCardAction.showError(clipCouponValidityExpiredText);
                        }
                        $self.addClass('not-clippable');
                        $self.find('.clip-red-ellipse').removeClass('red-ellipse-plus').html('<img data-src="/images/shared/small/icons/lock-coupon.svg" class="inject-me" alt=""/>');
                        injectSVG($couponTile.get(0));
                        $clipBtns.attr('title', titleClipNotAllowed);
                        ClipToCardAction.disableElement($clipBtns);
                    } else {
                        $self.attr('title', titleTextClip);
                        ClipToCardAction.showError(clipErrorMsg);
                        ClipToCardAction.enableElement($clipBtns);
                    }
                }
            }
        });
    },

    recordUnclipEvent: function (couponId, xcCouponId) {
        var urlToCall = "/my-coupon/recordUnclipFromCardEvent";
        $.ajax({
            url: urlToCall,
            type: "POST",
            xhrFields: {
                withCredentials: true
            },
            data: {
                couponId: couponId,
                xcCouponId: xcCouponId
            },
            headers: {
                "Accept-Language": lang
            },
            error: function (jqXHR) {
                TINK.redirectIfConflict(jqXHR);
            }
        });
    },

    showError: function (msg) {
        if ($('.alert--error').length) {
            $('.alert--error').hide();
        }
        $("#clip-error").html(msg);
        $("#clip-error").show();
        $('html, body').animate({scrollTop: 200}, 'fast');
    },

    refreshButtonForClip: function ($self) {
        var $couponTile = $self.closest('article.coupon--bloc');
        var cannotBeClipped = $couponTile.hasClass('clippedDisplayDateExpired');
        if (cannotBeClipped) {
            $self.remove();
            return;
        }
        $self.removeClass('clipped');
        $self.find('.clip-red-ellipse').removeClass('red-ellipse-remove').addClass('red-ellipse-plus');
        $self.attr('title', titleTextClip);
        $self.removeAttr("data-coupon-xcid");
    },

    refreshButtonForUnclip: function ($self, xcCouponId, unclippable) {
        $self.addClass('clipped');
        var $clipEllipseActionIndicator = $self.find('.clip-red-ellipse');
        $clipEllipseActionIndicator.removeClass('red-ellipse-plus');
        if (unclippable) {
            $self.attr('title', titleTextUnclip);
            $self.attr('data-coupon-xcid', xcCouponId);
            $clipEllipseActionIndicator.addClass('red-ellipse-remove');
        } else {
            $self.addClass('not-unclippable');
            $clipEllipseActionIndicator.addClass('red-ellipse-checked');
            $self.attr('title', titleUnclipNotAllowed);
        }
    },

    refreshCouponHeaderForClip: function ($couponTile) {
        var $couponHeader = $couponTile.find('.coupon--header');
        $couponHeader.removeClass('coupon--header-overlay').removeClass('coupon-clipped').addClass('coupon-not-clipped');
        $couponHeader.find('button.coupons-ctc-header-button').removeClass('clip');
        $couponHeader.find('img').addClass('hide');
        var headerAccessibilityAdd = $couponHeader.data('coupon-header-accessibility-add');
        $couponHeader.find('button.coupons-ctc-header-button').prop('title', headerAccessibilityAdd);
    },

    refreshCouponHeaderForUnclip: function ($couponTile, unclippable) {
        var $couponHeader = $couponTile.find('.coupon--header');
        $couponHeader.addClass('coupon--header-overlay').addClass('coupon-clipped');
        $couponHeader.find('img.hide').removeClass('hide');
        var headerAccessibilityRemove = $couponHeader.data('coupon-header-accessibility-remove');
        $couponHeader.find('button.coupons-ctc-header-button').prop('title', headerAccessibilityRemove);

        if (unclippable) {
            $couponHeader.find('button.coupons-ctc-header-button').addClass('clip');
        } else {
            $couponHeader.addClass('coupon-unclippable');
            $couponHeader.find('button.coupons-ctc-header-button').remove();
        }
    },

    refreshNbItemsDisplay: function (nbItems) {
        $('.coupons-ctc--number').html(nbItems);
    },

    refreshNbItemsInShoppingList: function (nbItems) {
        $('.mlb--number').html(nbItems);
    },

    incrementClippedDisplayCount: function () {
        var previousCount = ClipToCardAction.getClippedPreviousCount();
        ClipToCardAction.refreshNbItemsDisplay(previousCount + 1);
    },

    decrementClippedDisplayCount: function () {
        var previousCount = ClipToCardAction.getClippedPreviousCount();
        ClipToCardAction.refreshNbItemsDisplay(previousCount - 1);
    },

    getClippedPreviousCount: function () {
        return parseInt($('.coupons-ctc--number').text());
    },

    refreshShoppingListItem: function ($this, decrement) {
        var slItemId = $this.closest('.sl--family-item').attr("data-item-id");
        var $container = $this.closest('.item-addToCart');
        ShoppingListUtil.refreshItem(slItemId, $container);
        ShoppingListUtil.updateCount($('#nbCoupons'), decrement);
        ClipToCardAction.initCouponModalDetails($this);
    },

    refreshActions: function () {
        if ($(".coupons-ctc-button").not(".clipped").length === 0) {
            $(".coupons-clip-all-btn").addClass('hide');
        } else {
            $(".coupons-clip-all-btn").removeClass('hide');
        }
    },

    initCouponModalDetails: function ($this) {
        $('[data-remodal-id=modal-coupon-legal' + $this.attr("data-coupon-id") + ']').remodal();
    },

    isActionFromShoppingList: function ($this) {
        return $this.closest('.sl--family-item').length > 0;
    },

    couponHelpModal: function () {
        if (localStorage.getItem('hideClipToCardModal ') !== "true") {
            localStorage.setItem('hideClipToCardModal ', 'true');
            $('[data-module~="dishide--coupon-help"]').dishide('destroy');
        }
    }
};